/* ============================================
   CENIT · Entregas (página de producto)
   - Calculadora por código postal, cuenta regresiva y textos de entrega.
   - Siempre con la hora de Ciudad de México (America/Mexico_City), no la del navegador.
   - Ajustes: Configuración del tema > CENIT · Entregas (snippets/cenit-entrega-config.liquid).
   - Prueba solo fuera del tema publicado: ?cenit_hora=2026-10-24T15:30 simula esa hora de CDMX.
   ============================================ */
(function () {
  'use strict';

  var cfgEl = document.getElementById('CenitEntregaConfig');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var TZ = 'America/Mexico_City';
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var STORE = 'cenitCp';

  var deliveryDays = String(cfg.dias || '').split(',').filter(Boolean).map(Number);
  var holidays = {};
  String(cfg.festivos || '').split(/[\s,;]+/).forEach(function (d) {
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) holidays[d] = true;
  });
  var cutoff = Number(cfg.corte) || 16;
  var cpFrom = parseInt(cfg.cpDesde, 10) || 1000;
  var cpTo = parseInt(cfg.cpHasta, 10) || 16999;

  /* ---------- Hora de CDMX ---------- */

  /* Pruebas: solo en el editor o en una vista previa (nunca en el tema publicado) */
  function testingAllowed() {
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    return !!cfg.editor || (role && role !== 'main');
  }
  var simulated = null;
  (function () {
    var raw = '';
    try { raw = new URLSearchParams(location.search).get('cenit_hora') || ''; } catch (e) {}
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(raw);
    if (m && testingAllowed()) {
      simulated = { y: +m[1], m: +m[2], d: +m[3], h: +m[4], min: +m[5], at: Date.now() };
    }
  })();

  /* Fecha civil en CDMX: { y, m, d, h, min } */
  function nowCdmx() {
    if (simulated) {
      var passed = Math.floor((Date.now() - simulated.at) / 60000);
      var t = simulated.h * 60 + simulated.min + passed;
      return { y: simulated.y, m: simulated.m, d: simulated.d, h: Math.floor(t / 60) % 24, min: t % 60 };
    }
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24, min: +parts.minute };
  }

  /* Días como enteros UTC para sumar sin problemas de horario de verano */
  function dayNum(c) { return Math.floor(Date.UTC(c.y, c.m - 1, c.d) / 864e5); }
  function fromNum(n) { var x = new Date(n * 864e5); return { y: x.getUTCFullYear(), m: x.getUTCMonth() + 1, d: x.getUTCDate(), dow: x.getUTCDay() }; }
  function iso(n) { var c = fromNum(n); return c.y + '-' + (c.m < 10 ? '0' : '') + c.m + '-' + (c.d < 10 ? '0' : '') + c.d; }

  function isDeliveryDay(n) { return deliveryDays.indexOf(fromNum(n).dow) > -1 && !holidays[iso(n)]; }
  function isBusinessDay(n) { var w = fromNum(n).dow; return w > 0 && w < 6 && !holidays[iso(n)]; }
  function nextWhere(n, test) { var i = 0; do { n++; i++; } while (!test(n) && i < 60); return n; }
  function addBusinessDays(n, k) { while (k > 0) { n++; if (isBusinessDay(n)) k--; } return n; }

  function longDate(n) { var c = fromNum(n); return DIAS[c.dow] + ' ' + c.d + ' de ' + MESES[c.m - 1]; }
  function shortDate(n) { var c = fromNum(n); return c.d + ' de ' + MESES[c.m - 1]; }
  function hourLabel(h) { var hh = h % 12 || 12; return hh + (h < 12 ? ' am' : ' pm'); }

  /* ---------- Reglas ---------- */

  /* Día de entrega en CDMX para un pedido hecho ahora */
  function cdmxDelivery() {
    var now = nowCdmx();
    var today = dayNum(now);
    var beforeCutoff = now.h < cutoff;
    var day = isDeliveryDay(today) && beforeCutoff ? today : nextWhere(today, isDeliveryDay);
    return { now: now, today: today, day: day, minutesLeft: day === today ? cutoff * 60 - (now.h * 60 + now.min) : 0 };
  }

  function relLabel(day, today) {
    if (day === today) return 'HOY, ' + longDate(day);
    if (day === today + 1) return 'mañana, ' + longDate(day);
    return 'el ' + longDate(day);
  }

  /* Resto de México: sale hoy si es día hábil antes del corte; si no, el siguiente día hábil */
  function nationalRange() {
    var now = nowCdmx();
    var today = dayNum(now);
    var ship = isBusinessDay(today) && now.h < cutoff ? today : nextWhere(today, isBusinessDay);
    return { from: addBusinessDays(ship, cfg.nacMin), to: addBusinessDays(ship, cfg.nacMax) };
  }

  function isCdmx(cp) { var n = parseInt(cp, 10); return n >= cpFrom && n <= cpTo; }

  /* ---------- Calculadora ---------- */

  function initCalculator(root) {
    var form = root.querySelector('[data-ce-form]');
    var input = root.querySelector('[data-ce-cp]');
    var out = root.querySelector('[data-ce-result]');
    var err = root.querySelector('[data-ce-error]');
    if (!form || !input || !out) return;

    function show(cp) {
      if (!/^\d{5}$/.test(cp)) {
        err.hidden = false;
        out.hidden = true;
        input.setAttribute('aria-invalid', 'true');
        return;
      }
      err.hidden = true;
      input.removeAttribute('aria-invalid');
      try { localStorage.setItem(STORE, cp); } catch (e) {}

      var title, note;
      if (isCdmx(cp)) {
        var c = cdmxDelivery();
        title = 'Llega ' + relLabel(c.day, c.today);
        note = c.day === c.today
          ? 'Entrega en CDMX el mismo día. Pide antes de las ' + hourLabel(cutoff) + '.'
          : 'Entrega en CDMX. Los pedidos antes de las ' + hourLabel(cutoff) + ' llegan el mismo día de entrega.';
        out.classList.add('is-today');
        out.classList.toggle('is-now', c.day === c.today);
      } else {
        var r = nationalRange();
        var sameMonth = fromNum(r.from).m === fromNum(r.to).m;
        title = r.from === r.to
          ? 'Llega el ' + longDate(r.from)
          : 'Llega entre el ' + (sameMonth ? fromNum(r.from).d : shortDate(r.from)) + ' y el ' + shortDate(r.to);
        note = 'Envío con rastreo. ' + cfg.nacMin + ' a ' + cfg.nacMax + ' días hábiles.';
        out.classList.remove('is-today', 'is-now');
      }
      out.querySelector('[data-ce-title]').textContent = title;
      out.querySelector('[data-ce-note]').textContent = note + ' CP ' + cp + '.';
      out.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      show(input.value.trim());
    });
    input.addEventListener('input', function () {
      input.value = input.value.replace(/\D/g, '').slice(0, 5);
      if (input.value.length === 5) show(input.value);
    });

    /* Recuerda el último CP que escribió la persona */
    var saved = null;
    try { saved = localStorage.getItem(STORE); } catch (e) {}
    if (saved && /^\d{5}$/.test(saved)) {
      input.value = saved;
      show(saved);
    }
  }

  /* ---------- Cuenta regresiva ---------- */

  function initCountdown(el) {
    var txt = el.querySelector('[data-ce-countdown-text]') || el;
    function paint() {
      var c = cdmxDelivery();
      if (c.day === c.today && c.minutesLeft > 0) {
        var h = Math.floor(c.minutesLeft / 60), m = c.minutesLeft % 60;
        var left = h && m ? h + ' h ' + m + ' min' : h ? h + ' h' : m + ' min';
        txt.innerHTML = 'Pide en las próximas <b>' + left + '</b> y recíbelo hoy en CDMX';
        el.classList.add('is-live');
      } else {
        var when = c.day === c.today + 1 ? 'mañana' : 'el ' + DIAS[fromNum(c.day).dow];
        txt.innerHTML = 'En CDMX: pide hoy y recíbelo <b>' + when + '</b>';
        el.classList.remove('is-live');
      }
      el.hidden = false;
    }
    paint();
    setInterval(paint, 30000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) paint(); });
  }

  /* ---------- Arranque ---------- */

  function init() {
    document.querySelectorAll('[data-ce-calc]').forEach(initCalculator);
    document.querySelectorAll('[data-ce-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-ce-cutoff]').forEach(function (el) { el.textContent = hourLabel(cutoff); });
    if (simulated) {
      var b = document.createElement('p');
      b.className = 'ce-sim';
      b.textContent = 'Prueba: hora simulada de CDMX ' + simulated.y + '-' + simulated.m + '-' + simulated.d + ' ' + simulated.h + ':' + (simulated.min < 10 ? '0' : '') + simulated.min;
      document.body.appendChild(b);
    }
  }

  window.cenitEntrega = { cdmx: cdmxDelivery, nacional: nationalRange, isCdmx: isCdmx, hourLabel: hourLabel };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
